module.exports = __webpack_public_path__ + "static/media/4.question_loop.df7ef285.mp4";